/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-expressions */
import React, { memo, useState, ChangeEvent } from 'react';
import { DraggableModal, DraggableModalProvider } from 'ant-design-draggable-modal';
import './upload-antenna-modal.less';
import { Button, Input } from 'antd';
import { useActions } from '../../providers/actions-provider/actions.context';

interface IUploadAntennaModalProps {
  visible: boolean;
  onCancel: () => void;
  facilityCode: string;
}

const UploadAntennaModal = (props: IUploadAntennaModalProps): JSX.Element => {
  const { visible, onCancel, facilityCode } = props;
  const { reportActions } = useActions();
  const [text, setText] = useState('');
  const [error, setError] = useState<string|null>(null);

  const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const fr = new FileReader();
    setError(null);
    const file = e.target.files?.[0];
    if (!file) return;

    const isJson = file.type === 'application/json'
    || file.name.toLowerCase().endsWith('.json');

    if (!isJson) {
      e.target.value = '';
      setText('');
      setError('Only json format is accepted');
      return;
    }

    fr.onload = function () {
      if (fr.result) {
        setText(fr.result.toString());
      }
    };

    if (e.target) {
      const input = e.target as HTMLInputElement;
      input.files && fr.readAsText(input.files[0]);
    }
  };

  const onImportClick = async () => {
    try {
      await reportActions.importAntennas({ group_code: facilityCode, data: text, type: 'text/plain' });
      setText('');
      onCancel();
    // eslint-disable-next-line no-empty
    } catch (err) {}
  };

  const onCancelHandler = () => {
    onCancel();
    setText('');
  };

  return (
    <DraggableModalProvider>
      <DraggableModal
        open={visible}
        initialWidth={600}
        initialHeight={400}
        title="Import Antennas"
        className="upload-antenna-modal"
        footer={null}
        onCancel={onCancelHandler}
      >
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '0px 0px',
        }}
        >
          <input type="file" accept=".json" onChange={onFileChange} />
          <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>
          <Button onClick={onImportClick} disabled={!text}>Import</Button>
        </div>
        <Input.TextArea className="upload-antenna-textarea" value={text} onChange={(e) => setText(e.target.value)} />
      </DraggableModal>
    </DraggableModalProvider>
  );
};

UploadAntennaModal.displayName = 'UploadAntennaModal';

export default memo(UploadAntennaModal);
